// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__vGyCR","pink":"About_pink__zMqXV","green":"About_green__chyFI","skills":"About_skills__UHCsb","textStyle":"About_textStyle__TCxJ3"};